import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Botão com indicador de progresso enquanto `loading` é true.
// API compatível com a versão MUI anterior (loading, disabled, variant, color, fullWidth).
//
// Props:
//   loading   — boolean, controla o estado de progresso
//   disabled  — boolean, também desabilita o botão
//   fullWidth — boolean, ocupa toda largura do container
//   variant   — "contained" | "outlined" | "text" (compat MUI) ou variant shadcn
//   ...       — props HTML padrão de <button>
const MUI_VARIANT_MAP = {
  contained: "default",
  outlined: "outline",
  text: "ghost",
};

export default function LoadingButton({
  loading = false,
  disabled,
  variant,
  color, // legado MUI, ignorado
  fullWidth = false,
  className,
  children,
  sx, // legado MUI, ignorado (compat com chamadas existentes)
  ...buttonProps
}) {
  const resolvedVariant = MUI_VARIANT_MAP[variant] ?? variant;

  return (
    <Button
      variant={resolvedVariant}
      disabled={loading || disabled}
      className={cn(fullWidth && "w-full", className)}
      {...buttonProps}
    >
      {/* role/aria-label tornam o estado de carregamento perceptível a leitores
          de tela — um <svg> decorativo sozinho não anuncia nada. */}
      {loading && (
        <Loader2
          className="mr-2 h-4 w-4 animate-spin"
          role="progressbar"
          aria-label="Carregando"
        />
      )}
      {children}
    </Button>
  );
}
